import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    ...theme.layouts.stepGrid,

    responsiveWidth: {
      '@media (max-width: 1279px)': {
        maxWidth: '100%',
      },
      maxWidth: '70%',
    },
    actionButton: {
      marginTop: '1rem',
      '& button': {
        minWidth: '13rem',
        '@media (min-width: 321px)': {
          minWidth: '18rem',
        },
      },
      '@media (max-width: 410px)': {
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'center',
        '& button': {
          margin: '1rem 0',
        },
      },
    },
    importantStatementsList: {
      '& a': {
        color: theme.palette.dark[800],
      },
    },
    bold: {
      fontWeight: 500,
    },
    noticeContainer: {
      padding: '1.5rem 1.5rem 1rem 1.5rem !important',
    },
    noticeLink: {
      display: 'inline-block',
      padding: '1rem 0',
    },
    noticeLinkIcon: {
      verticalAlign: 'middle',
      marginLeft: '0.5rem',
      color: theme.palette.dark[600]
    },
  }),
  { index: 1 },
);
